import "../style.scss";
import Close from "./Close";
import Link from "./Link";

const OverlayShare = ({
  title,
  descriptionOne,
  descriptionTwo,
  text,
  url,
  closeOverlay,
}) => {
  return (
    <div className={"overlayShare"}>
      <div className={"popup"}>
        <div className={"popupClose"}>
          <Close handleCloseModal={closeOverlay} />
        </div>
        <div className={"popupContent"}>
          <h1 className={"popupTitle"}>{title}</h1>
          <div className={"popupDescription"}>
            <p>{descriptionOne}</p>
            <p>{descriptionTwo}</p>
          </div>
          <div className={"popupActions"}>
            <Link text={text} url={url} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default OverlayShare;
